module.exports = __webpack_public_path__ + "media/_/_/_/siqmain/app/javascript/components/images/onelogin_logo-88ddbb25745d399b745dd39bd4f0902a.svg";